import { useEffect, useState } from 'react';
import { checkBackendHealth } from '../api/contentApi';
import { isBackendUnavailable } from '../utils/backendError';

export const useBackendHealth = () => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let isMounted = true;

    const verify = async () => {
      try {
        await checkBackendHealth();
        if (isMounted) {
          setStatus('available');
        }
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setStatus(isBackendUnavailable(error) ? 'unavailable' : 'available');
      }
    };

    verify();

    return () => {
      isMounted = false;
    };
  }, []);

  return { status, isChecking: status === 'checking', isUnavailable: status === 'unavailable' };
};
